// extracted by mini-css-extract-plugin
module.exports = {"root":"Completed_root__ByvF8","label":"Completed_label__DJ6Ek"};